export enum AddressTypeEnum {
  BILLING = 'billing',
  SHIPPING = 'shipping'
}
